module.exports = __webpack_public_path__ + "img/splash.d2720834.png";